import { render, staticRenderFns } from "./DataSheet.vue?vue&type=template&id=f0b8c9ec&scoped=true"
import script from "./DataSheet.vue?vue&type=script&lang=js"
export * from "./DataSheet.vue?vue&type=script&lang=js"
import style0 from "./DataSheet.vue?vue&type=style&index=0&id=f0b8c9ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b8c9ec",
  null
  
)

export default component.exports